import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error('Dashboard Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div dir="rtl" className="min-h-screen bg-void text-white p-8 font-cairo">
          <div className="max-w-4xl mx-auto">
            <div className="bg-red-900/30 border border-red-700 rounded-2xl p-8 mb-6">
              <h1 className="text-2xl font-bold mb-4 text-red-300">⚠️ خطأ في تحميل لوحة التحكم</h1>
              <p className="mb-4">حدث خطأ في تحميل لوحة التحكم. جاري إصلاح المشكلة تلقائياً.</p>
              
              <div className="bg-black/50 p-4 rounded-lg mb-4 overflow-auto">
                <p className="text-sm opacity-75 mb-2">تفاصيل الخطأ (للمطورين):</p>
                <code className="text-xs text-red-300">
                  {this.state.error && this.state.error.toString()}
                </code>
              </div>

              <div className="flex flex-wrap gap-4">
                <button
                  onClick={() => window.location.reload()}
                  className="px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-lg font-semibold transition"
                >
                  ↻ إعادة تحميل الصفحة
                </button>
                
                <button
                  onClick={() => {
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.reload();
                  }}
                  className="px-6 py-3 bg-amber-600 hover:bg-amber-700 rounded-lg font-semibold transition"
                >
                  🧹 مسح الذاكرة وإعادة تحميل
                </button>

                <a
                  href="/"
                  className="px-6 py-3 bg-gray-700 hover:bg-gray-600 rounded-lg font-semibold transition inline-flex items-center"
                >
                  🏠 العودة للرئيسية
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-gray-800/50 border border-gray-700 rounded-2xl p-6">
                <h3 className="text-lg font-semibold mb-3">🛠️ إصلاح سريع</h3>
                <ul className="space-y-2 text-sm">
                  <li>• اضغط Ctrl+F5 (إعادة تحميل قسري)</li>
                  <li>• امسح cache المتصفح (Ctrl+Shift+Delete)</li>
                  <li>• جرب نافذة خاصة (Incognito)</li>
                  <li>• تأكد من اتصال الإنترنت</li>
                </ul>
              </div>

              <div className="bg-gray-800/50 border border-gray-700 rounded-2xl p-6">
                <h3 className="text-lg font-semibold mb-3">📞 الدعم الفني</h3>
                <p className="text-sm mb-3">إذا استمرت المشكلة:</p>
                <ul className="space-y-2 text-sm">
                  <li>• صور شاشة الـ Console (F12)</li>
                  <li>• أرسل الصورة للدعم الفني</li>
                  <li>• اذكر نوع المتصفح والإصدار</li>
                </ul>
              </div>
            </div>

            <div className="mt-8 text-center text-gray-400 text-sm">
              <p>Sanajim Command Center • الإصدار 3.0 • {new Date().toLocaleDateString('ar-SA')}</p>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;